import LayerBackButton from "../LayerBackButton";
import { FacetTypes } from "../../../facets/Facets";
import { LabelUI } from "../../ui/LabelUI";
import { WorldPos3D } from '../../ui/positions';
import { CONTENT_ANCHORING } from '../../ui/PositionedUI';
import { LABEL_HEIGHT_PX } from './LevelPlacer';
import {
  CallbackOnEvent, DispatchEventOnHover, ExpandOnHover, HighlightDeferredOnHover, HighlightFacetOnHover, NestedMouseInteractionsPlugin,
  SelectDeferredOnClick, SelectFacetOnClick, UiCollision } from
'../../ui/plugins';

import { ClusteredCounts } from "../../ui/ClusterUI";
const CLUSTER_REL_OFFSET = { top: '-10px', left: '100%', transform: 'translate(-2px, 0)' };

export class LevelLabelUI extends LabelUI {
  #estimatedSize = { width: 100, height: LABEL_HEIGHT_PX };

  constructor(hud, layer, pos3D, level) {
    super(hud, layer, new WorldPos3D(pos3D), level.id, CONTENT_ANCHORING.END);
    this.labelHost.classList.add('hud-level');

    this.data.node = level;
    this.data.facetType = FacetTypes.levels;
    this.data.deferred = [];

    this.isSelected = false;
    this.isCollapsed = false;
    this.eventTarget = this.labelHost;
    this.collisionTarget = this.labelHost;
    this.children = [];

    this.plugins.push(new UiCollision());
    this.plugins.push(new NestedMouseInteractionsPlugin());
    this.plugins.push(new ExpandOnHover());
    this.plugins.push(new CallbackOnEvent('dblclick', (e) => layer.onDblClick(e, level)));

    // Create a child object to represent only the text area of the label for eventing
    this.textBox = { eventTargets: [this.textHost], plugins: [] };
    this.textBox.plugins.push(new SelectFacetOnClick());
    this.textBox.plugins.push(new HighlightFacetOnHover());
    this.children.push(this.textBox);

    // Asset cluster integration
    const document = hud.getDocument();
    this.assetsCounts = new ClusteredCounts(document, CLUSTER_REL_OFFSET);
    this.assetsCounts.init(this.labelHost);
    this.assetsCounts.plugins.push(new SelectDeferredOnClick());
    // Disabled due to too many involuntary triggering during early navigation.
    //this.assetsCounts.plugins.push(new HighlightDeferredOnHover(this.assetsCounts.dom));
    this.assetsCounts.plugins.push(new DispatchEventOnHover());
    this.children.push(this.assetsCounts);

    // TODO: refactor backBtn?
    this.backBtn = new LayerBackButton(hud.twin.facetsManager, document, FacetTypes.levels, level.id);
    this.backBtn.attachToUI(this);
  }

  setSelected(value, faded) {
    if (value) {
      this.labelHost.classList.add("hud-level-selected");
      this.backBtn.show();
      this.updateDimensionsOnNextFrame();
    } else {
      this.labelHost.classList.remove("hud-level-selected");
      this.backBtn.hide();
      this.updateDimensionsOnNextFrame();
    }

    if (faded && !value) {
      this.labelHost.classList.add("hud-level-fade");
      this.textHost.classList.add("hud-level-text-fade");
    } else {
      this.labelHost.classList.remove("hud-level-fade");
      this.textHost.classList.remove("hud-level-text-fade");
    }

    this.isSelected = value;

    if (this.isSelected) {
      this.uncollapse();
    }
  }

  updateWithDeferred(deferredAssets) {
    this.data.deferred.length = 0;
    for (const asset of deferredAssets) {
      this.data.deferred.push(asset);
    }

    this.assetsCounts.updateFromList(this.data.deferred);
  }

  setEstimatedSize({ width, height }) {
    this.#estimatedSize.width = width;
    this.#estimatedSize.height = height ?? LABEL_HEIGHT_PX;
  }

  getEstimatedSize() {
    return this.isCollapsed ? this.assetsCounts.getEstimatedSize() : this.#estimatedSize;
  }

  collapse() {
    // Nothing to collapse into
    if (!this.assetsCounts.isVisible || this.isCollapsed || this.isSelected) return;

    this.isCollapsed = true;
    this.textHost.style.display = 'none';
    this.labelHost.classList.add('hud-level-collapsed');
    this.assetsCounts.dom.style.transform = 'translateX(-100%)';

    // Immediate inval so estimated size is used
    this.dimensions = null;
    this.updateDimensionsOnNextFrame();
  }

  uncollapse() {
    if (!this.isCollapsed) return;

    this.isCollapsed = false;
    this.textHost.style.display = 'flex';
    this.labelHost.classList.remove('hud-level-collapsed');
    this.assetsCounts.dom.style.transform = CLUSTER_REL_OFFSET.transform;

    // Immediate inval so estimated size is used
    this.dimensions = null;
    this.updateDimensionsOnNextFrame();
  }
}